import "../styles/replyForm.scss";
import noAvatarImg from "../../../assets/noAvatar.png";

const ReplyForm = ({ currentUser, value, onChange, onSubmit, targetName, isPending, cooldown, logicType, onLogicTypeChange }) => {
    // const getAvatarSrc = (pic) => (!pic ? "/public/noAvatar.png" : pic.startsWith("http") ? pic : "/upload/" + pic);

    const getAvatarSrc = (pic) => (!pic ? noAvatarImg : pic.startsWith("http") ? pic : "/upload/" + pic);

    const isDisabled = isPending || cooldown > 0;

    return (
        <div className="write replyInput">
            <img
                src={getAvatarSrc(currentUser.profilePic)}
                alt=""
            />

            <select 
                value={logicType} 
                onChange={(e) => onLogicTypeChange(e.target.value)}
                disabled={isDisabled}
                className={`logic-selector ${logicType.toLowerCase()}`}
            >
                <option value="CLARIFICATION">
                    Clarify 
                </option>

                <option value="CRITIQUE">
                    Critique
                </option>

                <option value="COUNTER_CRITIQUE">
                    Counter
                </option>
            </select>
            
            <input
                type="text"
                placeholder={cooldown > 0 ? `Please wait ${cooldown}s...` : `Replying to ${targetName}...`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={isDisabled}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !isDisabled) onSubmit();
                }}
            />

            <button onClick={onSubmit}>
                {cooldown > 0 ? `Wait ${cooldown}s` : (isPending ? "Sending..." : "Send")}
            </button>
        </div>
    );
};

export default ReplyForm;